import React, {useState, useEffect} from "react";
import {memo} from "react";
import "../../styles/phone-input.css";
import validator from "validator";
import {
	createAccount,
	sendingCode,
	setLocalStorageWithTimer,
	verifyCode,
	postHelper,
	BASE_URL
} from "../../general/helper";
import Loading from "../common/Loading";
import Phone from "../common/Phone";
import Pin from "../common/Pin";
import useAuth from "../../hooks/useAuth";
import {useNavigate, useLocation} from 'react-router-dom';

const TwoFA = memo(
	({lid}) => {
		const {loginWith2FA} = useAuth();
		const navigate = useNavigate();
		const location = useLocation();
		const [geoInfo, setGeoInfo] = useState();
		const [phone, setPhone] = useState("");
		const [sendCode, setSendCode] = useState(false);
		const [loading, setLoading] = useState(false);
		const [error, setError] = useState(false);
		
		const {activityId, adultsNames, notes, numberOfAdults} = location.state || {};
		
		const getGeoInfo = () => {
			fetch("https://ipapi.co/json/")
				.then((response) => response.json()) // Parse the response as JSON
				.then((data) => {
					setGeoInfo(data);
				})
				.catch((error) => {
					console.log(error);
				});
		};
		
		useEffect(() => {
			getGeoInfo();
		}, []);
		
		const sendCodeHandler = async (phone) => {
			const isValid = validator.isMobilePhone(`+${phone}`);
			if (isValid) {
				setError(false);
				setLoading(true);
				const isSent = await sendingCode(phone, lid);
				setLoading(false);
				if (isSent === true) {
					setSendCode(true);
				}
			} else {
				setError(true);
			}
		};
		
		const verifyPinHandler = async (pin) => {
			const verifyPayload = JSON.stringify({
				code: `${pin}`,
				mobileNumber: phone,
				accommodationId: lid,
			});
			
			setLoading(true);
			// console.log('Verifying code with payload:', verifyPayload);
			const isVerify = await verifyCode(lid, verifyPayload);
			// console.log('Verification result:', isVerify);
			
			if (isVerify === true) {
				setError(false);
				setLocalStorageWithTimer(`verifiedMobile-${lid}`, phone, 900000);
				// console.log(`Verified mobile set in local storage: verifiedMobile-${lid}`);
				const loyaltyToken = await loginWith2FA(phone);
				// console.log('Login success after verification:', loyaltyToken);
				
				
				if (loyaltyToken) {
					await bookActivity(loyaltyToken);
				} else {
					const newAccountPayload = JSON.stringify({
						email: { email: `${phone}@exclusivi.com` },
						firstName: adultsNames[0]?.split(' ')[0] || "",
						lastName: adultsNames[0]?.split(' ')[1] || "",
						phoneNumber: `+${phone}`,
						password: `+${phone}`,
						marketingConsent: { hasConsent: false },
					});
					
					const accountCreated = await createAccount(lid, newAccountPayload);
					// console.log('Account creation response:', accountCreated);
					
					if (accountCreated.id) {
						const loyaltyTokenAfterCreation = await loginWith2FA(phone);
						// console.log('Login success after account creation:', loyaltyTokenAfterCreation);
						
						if (loyaltyTokenAfterCreation) {
							await bookActivity(loyaltyTokenAfterCreation);
						} else {
							setError(true);
							setLoading(false);
						}
					} else {
						setError(true);
						setLoading(false);
					}
				}
			} else {
				setLoading(false);
				setError(true);
			}
		};
		
		const bookActivity = async (loyaltyToken) => {
			if (!loyaltyToken) {
				setError(true);
				setLoading(false);
				return;
			}
			try {
				const bookActivityResponse = await postHelper(
					`${BASE_URL}/activitiesSchedule/guest/events/${activityId}/bookings`, JSON.stringify({
						adultsNames,
						notes,
						numberOfAdults
					}),
					{authorization: `token ${loyaltyToken}`}
				);
				if (!bookActivityResponse?.participantId) {
					setError(true);
					setLoading(false);
				} else {
					navigate(`/?lid=${lid}`);
				}
			} catch (error) {
				setError(true);
				setLoading(false);
			}
		};
		
		return (
			<>
				{loading ? (
					<Loading/>
				) : (
					<div className="w-full max-w-lg mx-auto px-4 py-6 pb-10 min-h-screen box-border">
						{!sendCode ? (
							<Phone
								error={error}
								phone={phone}
								setPhone={setPhone}
								geoInfo={geoInfo}
								sendCodeHandler={sendCodeHandler}
							/>
						) : (
							<Pin
								error={error}
								verifyPinHandler={verifyPinHandler}
								sendCodeHandler={() => sendCodeHandler(phone)}
							/>
						)}
					</div>
				)}
			</>
		);
	}
);

export default TwoFA;
